import { render } from "./armada.vue?vue&type=template&id=071c8f50"
import script from "./armada.vue?vue&type=script&lang=js"
export * from "./armada.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__